(function () {
  const modal = document.querySelector('[data-ibscent-search-modal]');
  if (!modal) return;

  const input = modal.querySelector('[data-ibscent-search-input]');
  const resultsBox = modal.querySelector('[data-ibscent-search-results]');
  const filters = modal.querySelector('[data-ibscent-search-filters]');
  const resetBtn = modal.querySelector('[data-ibscent-search-reset]');
  const form = modal.querySelector('[data-ibscent-search-form]');
  const triggers = document.querySelectorAll('[data-ibscent-search-open]');
  const closers = modal.querySelectorAll('[data-ibscent-search-close]');

  let lastFocus = null;
  let abortCtrl = null;
  let debounceTimer = null;

  function open() {
    lastFocus = document.activeElement;
    modal.setAttribute('data-open', 'true');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => input.focus(), 50);
  }

  function close() {
    modal.removeAttribute('data-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    document.body.classList.remove('gl-search-open');
    input.value = '';
    resultsBox.hidden = true;
    resultsBox.innerHTML = '';
    filters.hidden = false;
    resetBtn.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showResults(html) {
    resultsBox.innerHTML = html;
    resultsBox.hidden = false;
    filters.hidden = true;
  }

  function clearResults() {
    resultsBox.hidden = true;
    resultsBox.innerHTML = '';
    filters.hidden = false;
  }

  async function fetchPredictive(term) {
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();
    const shopifyRoutes = window.Shopify && window.Shopify.routes;
    const routeRoot = (shopifyRoutes && shopifyRoutes.root) || '/';
    const productNumber = term.replace(/^(#|no\.?\s*|number\s*)/i, '');
    const isNumberSearch = /^\d+$/.test(productNumber);
    const query = isNumberSearch ? `#${productNumber}` : term;
    const url = `${routeRoot}search/suggest?q=${encodeURIComponent(query)}&section_id=ibscent-predictive-search&resources[type]=product,collection,query&resources[options][fields]=title,product_type,variants.title,vendor,tag,body&resources[limit]=8`;
    try {
      const res = await fetch(url, { signal: abortCtrl.signal });
      const text = await res.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const section = doc.querySelector('.ibscent-predictive, .ibscent-predictive__empty');
      if (section) {
        showResults(section.outerHTML);
      } else {
        clearResults();
      }
    } catch (e) {
      if (e.name !== 'AbortError') console.warn('predictive search failed', e);
    }
  }

  input.addEventListener('input', () => {
    const term = input.value.trim();
    resetBtn.hidden = term.length === 0;
    clearTimeout(debounceTimer);
    if (term.length < 2 && !/^\d$/.test(term)) {
      clearResults();
      return;
    }
    debounceTimer = setTimeout(() => fetchPredictive(term), 180);
  });

  resetBtn.addEventListener('click', () => {
    input.value = '';
    resetBtn.hidden = true;
    clearResults();
    input.focus();
  });

  triggers.forEach(t => t.addEventListener('click', (e) => { e.preventDefault(); open(); }));
  closers.forEach(c => c.addEventListener('click', (e) => { e.preventDefault(); close(); }));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.getAttribute('data-open') === 'true') close();
  });

  form.addEventListener('submit', () => {
    document.body.style.overflow = '';
  });
})();
